import moment from 'moment';
import { useEffect, useState } from 'react';

function OngoingCallTime({ startedAt, endTime }) {
    const [time, setTime] = useState('--:--:--');

    useEffect(() => {
        let timer;
        if (!startedAt || !moment(startedAt).isValid()) return;
        const updateDiff = () => {
            const end = endTime ? moment(endTime) : moment();
            const start = moment(startedAt);
            const diff = end.diff(start);
            setTime(moment.utc(diff).format('HH:mm:ss'));
        };
        if (endTime) {
            if (moment(endTime).isValid()) {
                updateDiff();
            }
        } else {
            updateDiff();
            timer = setInterval(updateDiff, 1000);
        }
        return () => {
            if (timer) clearInterval(timer);
        };
    }, [endTime, startedAt]);
    return <div>{time}</div>;
}

export default OngoingCallTime;
